export default "__VITE_ASSET__CzzryjSl__"